import Dashboard from 'pages/Dashboard'

export default [
    {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
            requiresAuth: true,
            title: 'Dashboard',
        },
        beforeEnter: (to, from, next) => {

            if (localStorage?.getItem('__IS_FOR_VERCEL__') === 'true') {
                return next('/connect/vercel')
            } else if (localStorage?.getItem('__IS_FOR_VERCEL_CONFIG__') === 'true') {
                setTimeout(() => {
                    return next(`/integrations${localStorage?.getItem('__VERCEL_CONFIG_SEARCH__')}`)
                }, 100)
            }

            next() // Proceed to dashboard
        },
    }
]
